import React, { PureComponent}from 'react';
import {Link} from 'react-router-dom';
import './Header.scss';
import logo from 'common/nohash/logo.png';
import DownloadApp from '../button/DownloadApp';
import TopUp from '../button/TopUp';
import utils from 'common/js/utils';

export default class Header extends PureComponent{
    constructor(props){
        super(props);

        this.state = {
            isShowTopupPanel: false
        }
        this.searchString = props.search;
    }
    
    render() {
        return (
            <header className="m-header">
                <Link to={ {pathname: "/", search: this.searchString} } className="logo">
                    <img src={logo} alt="虎牙直播" />
                </Link>
                { utils.hideGift ?
                    null :
                    <TopUp className="btn-top-up clickstat" dataStat="Click/home/recharge|点击/首页/充值" fShowPayPanel={this.props.fShowPayPanel}>充值</TopUp>
                }
            </header>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/components/header/Header.jsx